import { useEffect, useState } from 'react';

const Delay = ({ waitTime, children }) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsReady(true);
    }, waitTime);

    return () => clearTimeout(timer);
  });
  return isReady ? children : null;
};

export default Delay;
